import script from "./CoinsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinsView.vue?vue&type=script&setup=true&lang=js"

import "./CoinsView.vue?vue&type=style&index=0&id=514a47f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514a47f2"]])

export default __exports__